<div class="dialog-grid">

    <div class="top">
        <h4>Agency Allocation</h4>
        <div class="close-icon">
            <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;"
                (click)="cancel()">close
            </mat-icon>
        </div>
    </div>

    <div *ngIf="!isShow" class="container">
        <div class="search-grid">
            <div style="position: absolute; top: 7px; left: 5px">
                <mat-icon style="color: rgba(222, 222, 222, 0.2);">
                    search　
                </mat-icon>
            </div>
            <input class="find" placeholder="Search" #search [(ngModel)]="searchInput">
        </div>

        <mat-list role="list" style="height: 336px;overflow-y: scroll;margin: 16px 0;">
            <mat-list-item role="listitem" *ngFor="let agency of agencyList;let i = index">
                <input type="checkbox" (change)="check($event, agency.id,i)"
                    [checked]="agencyCheckBoxSelected(agency.id)" class="allocate_checkbox">
                <!-- <img [src]="SERVER_URL+ '/images/company_'+ agency.id + '/' + agency.logo" class="logo-img"> -->
                <label class="name">{{ agency.name }}</label>
            </mat-list-item>
        </mat-list>

        <div class="button-grid mt_30">
            <!-- <button mat-button class="replay" (click)="reset()">
                <mat-icon style="font-size: 20px">replay</mat-icon>
                <label style="font-size: 14px">Reset</label>
            </button> -->
            <button mat-flat-button class="change-status-button" (click)="allocate(true)">Allocate</button>
        </div>
    </div>


    <div *ngIf="isShow">
        <div class="title fc_DEDEDE" style="margin: 20px 0 16px 0">You are allocating propety</div>
        <div style="padding: 0 33px;">
            <mat-chip-list>
                <mat-basic-chip *ngFor="let e of selectedProperties" class="unit-num">
                    {{e.unitNum}}
                </mat-basic-chip>
            </mat-chip-list>
        </div>


        <div class="title" style="margin: 16px 0">to agency</div>

        <mat-list role="list" style="height: 275px;overflow:auto;margin-bottom: 16px" class="border-bottom">
            <mat-list-item role="listitem" *ngFor="let index of agencyIndex;">
                <img [src]="SERVER_URL+ '/images/company_'+ agencyList[index].id + '/' + agencyList[index].logo"
                    class="logo-img">
                <label class="name">{{ agencyList[index].name }}</label>
            </mat-list-item>

        </mat-list>

        <div class="flex justify-betwwen align-center pd_20">
            <button mat-flat-button class="back_button" style="margin-right: 10px"
                (click)="allocate(false)">Back</button>
            <button mat-flat-button class="confirm_button" (click)="confirm()">Confirm</button>
        </div>
    </div>

</div>